import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { ko } from "date-fns/locale";
import { useEffect, useRef, useState } from "react";
import { DateRange, Range, RangeKeyDict } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { getKorDate } from "utils/date";

const DateFilter = ({
  startDate = new Date(),
  endDate = new Date(),
  maxDate,
  onChange,
}: {
  onChange?: (start: Date, end: Date) => void;
  startDate?: Date;
  endDate?: Date;
  maxDate?: Date;
}) => {
  const [openCalendar, setOpenCalendar] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (event: any) => {
      if (openCalendar && ref.current && !ref.current.contains(event.target)) {
        setOpenCalendar?.(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [openCalendar]);

  const [state, setState] = useState<Range>({
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  });

  return (
    <Container onClick={() => setOpenCalendar(true)}>
      <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
        {getKorDate(startDate.toDateString())} ~ {getKorDate(endDate.toDateString())}
      </UI.Typography>
      <div className="interaction" />
      <div ref={ref} className="calendar" style={{ display: openCalendar ? "flex" : "none" }}>
        <DateRange
          showDateDisplay={false}
          onChange={(date: RangeKeyDict) => {
            const start = date.selection.startDate;
            const end = date.selection.endDate;

            if (start && end) {
              setState({
                startDate: start,
                endDate: end,
                key: "selection",
              });
              onChange?.(start, end);
            }
          }}
          months={1}
          ranges={[state]}
          locale={ko}
          maxDate={maxDate}
        />
      </div>
    </Container>
  );
};

export default DateFilter;

const Container = styled.div`
  position: relative;
  display: flex;
  padding: 4px 12px;
  align-items: center;

  border-radius: 8px;
  background: var(--component-color-fill-normal);
  cursor: pointer;

  .interaction {
    left: 0;
    top: 0;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    position: absolute;
    &:hover {
      background-color: var(--alias-color-label-normal);
      opacity: 0.06;
    }
    &:active {
      background-color: var(--alias-color-label-normal);
      opacity: 0.09;
    }
  }

  .calendar {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 10;

    box-shadow: var(--alias-style-shadow-strong);
  }
`;
